export default "__VITE_ASSET__CFqIhl_g__"